import { TopBar } from '@nrg/design-system';
import { useFeatureFlag } from '@/featureFlags';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import styles from './AppTopBar.module.css';
import { AppBreadcrumb } from './sections/AppBreadcrumb';
import { LanguageChips } from './sections/LanguageChips';
import { NotificationButton } from './sections/NotificationButton';
import { SearchField } from './sections/SearchField';

const LG_MIN_WIDTH = '1024px';
const MD_MIN_WIDTH = '768px';

export function AppTopBar() {
  const isLg = useMediaQuery(`(min-width: ${LG_MIN_WIDTH})`);
  const isMd = useMediaQuery(`(min-width: ${MD_MIN_WIDTH})`);
  const searchEnabled = useFeatureFlag('globalSearch');
  const notificationsEnabled = useFeatureFlag('globalNotifications');

  return (
    <TopBar
      density={isLg ? 'comfortable' : 'compact'}
      start={<AppBreadcrumb />}
      {...(searchEnabled && isMd
        ? {
            center: (
              <div className={styles.center}>
                <SearchField variant="inline" />
              </div>
            ),
          }
        : {})}
      end={
        <div className={styles.end}>
          {searchEnabled && !isMd && <SearchField variant="iconTrigger" />}
          <LanguageChips />
          {notificationsEnabled && <NotificationButton />}
        </div>
      }
    />
  );
}
